// Shared-element page transitions for story cards.
//
// Turbo wraps each Drive render in document.startViewTransition (the layout opts in with
// <meta name="view-transition">). The story page names its title and cover in CSS; here we give the
// *clicked* card's title and cover the same names, so the browser morphs one into the other.
// Names must be unique on a page, which is why cards aren't named statically — a feed can list the
// same story twice, and a duplicate name cancels the whole transition.
//
// Going back from a story, the card for that story on the incoming page is named the same way,
// so the title flies back into its slot.

const NAMES = { title: "story-title", cover: "story-cover" }

function clearNames(root) {
  root.querySelectorAll("[data-vt]").forEach((el) => el.style.setProperty("view-transition-name", "none"))
}

function nameCard(card) {
  for (const [key, name] of Object.entries(NAMES)) {
    const el = card.querySelector(`[data-vt="${key}"]`)
    if (el) el.style.setProperty("view-transition-name", name)
  }
}

document.addEventListener("click", (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return
  const link = event.target.closest?.("a[href]")
  const card = link?.closest("[data-vt-story]")
  if (!card || !link.getAttribute("href")?.includes(`/stories/${card.dataset.vtStory}`)) return
  clearNames(document)
  nameCard(card)
})

document.addEventListener("turbo:before-render", (event) => {
  // From here on, pages arrive through a view transition; story.css drops its own entrance
  // animation so the two don't fight.
  document.documentElement.classList.add("turbo-nav")

  const leaving = document.querySelector(".story-page [data-reading-mode-target='title']")?.closest(".story-page")
  const slug = leaving && location.pathname.match(/^\/stories\/([^/?#]+)/)?.[1]
  const newBody = event.detail?.newBody
  if (!slug || !newBody || newBody.querySelector(".story-page")) return
  const card = newBody.querySelector(`[data-vt-story="${CSS.escape(decodeURIComponent(slug))}"]`)
  if (card) nameCard(card)
})

// A story image that fails to load (deleted upload, URL signed under an old key) should disappear,
// not show a broken-image icon. Front-page thumbnails collapse; a lead story falls back to its
// typographic layout. Error events don't bubble, hence the capture listener.
function dropBrokenImage(img) {
  const lead = img.closest(".home-lead")
  if (lead) {
    img.closest(".home-lead__media")?.remove()
    lead.classList.add("home-lead--text")
    return
  }
  img.closest(".story-row__thumb, .story-cover")?.remove()
}

document.addEventListener("error", (event) => {
  if (event.target instanceof HTMLImageElement) dropBrokenImage(event.target)
}, true)

// Images above the fold can fail before this deferred module even runs; sweep for those.
document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".home-lead__media img, .story-row__thumb img, .story-cover img").forEach((img) => {
    if (img.complete && img.naturalWidth === 0) dropBrokenImage(img)
  })
})
